import { ITaskStateEditItem, TaskStateEditItem } from "./taskStateEditItem";

export interface ITaskStateEdit {
    item: ITaskStateEditItem;
}

export class TaskStateEdit implements ITaskStateEdit {
    item: TaskStateEditItem;

    constructor();
    constructor(obj: ITaskStateEdit);
    constructor(obj?: any) {
        this.item = new TaskStateEditItem(obj ? obj.item : null);
    }
}